<template>
  <page-container>
    <template v-slot:page-fixed-header>
      <span class="text-h5 font-weight-bold ml-3 full-width page-header">{{
        $t("menu.dashboard")
      }}</span>
      <v-spacer></v-spacer>
      <span class="editable-mod-text warning--text" v-if="editable">
        <v-icon left size="20" color="warning">mdi-alert</v-icon
        >{{ $t("widget.layoutEditMode") }}
      </span>
      <v-spacer></v-spacer>
      <a-menu
        v-model="settingMenu"
        offset-y
        :close-on-content-click="false"
        :close-on-click="!showWidgetDialog"
        dense
      >
        <template v-slot:activator="{ on, attrs }">
          <a-btn v-bind="attrs" v-on="on" color="primaryDark">
            <v-icon left>mdi-cog</v-icon> {{ $t("widget.dashboardSettings") }}
            <v-icon v-if="settingMenu" right>mdi-menu-up</v-icon>
            <v-icon v-else right>mdi-menu-down</v-icon>
          </a-btn>
        </template>
        <v-list dense>
          <v-list-item-group mandatory>
            <v-list-item>
              <v-list-item-icon>
                <v-switch
                  v-model="editable"
                  flat
                  dense
                  class="mt-0"
                  style="height: 28px; width: 32px"
                ></v-switch>
              </v-list-item-icon>

              <v-list-item-content @click="editable = !editable">
                {{ $t("widget.layoutEditMode") }}
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item v-if="editable" @click="saveDashboardChanges">
              <v-list-item-icon>
                <v-icon left>mdi-tag</v-icon>
              </v-list-item-icon>
              <v-list-item-content
                ><span>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-on="on" v-bind="attrs">{{
                        $t("widget.saveLayout")
                      }}</span>
                    </template>
                    <span>{{ $t("widget.saveLayoutToolTip") }}</span>
                  </v-tooltip>
                </span></v-list-item-content
              >
            </v-list-item>

            <v-list-item
              v-if="$security.checkUserAccess('CreateDashboard')"
              @click.stop="saveDefaultWidgetSettings"
            >
              <v-list-item-icon>
                <v-icon left>mdi-content-save</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-on="on" v-bind="attrs">{{
                      $t("widget.saveDefaultDashboard")
                    }}</span>
                  </template>
                  <span>{{ $t("widget.saveDefaultDashboardToolTip") }}</span>
                </v-tooltip>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click.stop="resetDefaultDashboard">
              <v-list-item-icon>
                <v-icon left>mdi-backup-restore</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-on="on" v-bind="attrs">{{
                      $t("widget.resetButton")
                    }}</span>
                  </template>
                  <span>{{ $t("widget.resetButtonToolTip") }}</span>
                </v-tooltip>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="editable" @click="openWidgetDialog">
              <v-list-item-icon>
                <v-icon left>mdi-application-cog</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                {{ $t("widget.addWidget") }}
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </a-menu>
      <WidgetConfiguration
        v-if="editable"
        v-model="showWidgetDialog"
      ></WidgetConfiguration>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            color="primaryDark"
            :disabled="zoom_type == 10"
            width="40"
            min-width="40"
            class="ml-2"
            @click="setZoom('out')"
            v-on="on"
            v-bind="attrs"
          >
            <v-icon size="20"> mdi-magnify-plus</v-icon>
          </a-btn>
        </template>
        <span>{{ percentage }}%</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            color="primaryDark"
            width="40"
            min-width="40"
            class="ml-2"
            @click="setZoom('in')"
            :disabled="zoom_type == 1"
            v-on="on"
            v-bind="attrs"
          >
            <v-icon size="20"> mdi-magnify-minus</v-icon>
          </a-btn>
        </template>
        <span>{{ percentage }}%</span>
      </v-tooltip>
    </template>
    <template v-slot:page-content>
      <v-card
        style="z-index: 0"
        class="dashboard-container"
        flat
        tile
        color="Neutral"
        v-resize="onResize"
      >
        <!-- main content declaration -->
        <v-card-text class="ml-0 mt-0 pl-0 pt-0 mr-2">
          <div class="control-section dashboard-default">
            <ejs-dashboardlayout
              ref="DashbordInstance"
              :columns="6"
              id="defaultLayout"
              :cellSpacing="spacing"
              :allowResizing="allowResizing"
              :allowDragging="allowDragging"
              :resizeStop="onPanelResize"
              :dragStop="onDragStop"
              :cellAspectRatio="cellAspectRatio"
              :mediaQuery="mediaQuery"
            >
            </ejs-dashboardlayout>
          </div>
        </v-card-text>
        <!--end of main content declaration -->
        <confirm-dialog ref="confirm"></confirm-dialog>
        <message-sheet
          :showMessage="displayMessage"
          :message="message"
          :messageType="messageType"
          @close="displayMessage = false"
        ></message-sheet>
        <prevent-navigation
          :prevent="isDashboardPanelmodified"
          @save="saveOnLeave"
          @discard="$event.next()"
          @cancel="$event.next(false)"
        ></prevent-navigation>
        <Loader :loading="Loaderloading" :message="LoaderText"></Loader>
      </v-card>
    </template>
  </page-container>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { DashboardLayoutPlugin } from "@syncfusion/ej2-vue-layouts";
import { ButtonPugin } from "@syncfusion/ej2-vue-buttons";

Vue.use(DashboardLayoutPlugin, ButtonPugin);
import UpcomingMeetingList from "./UpcomingMeetiingList.vue";
import UpcomingSurveyList from "./UpcomingSurveyList.vue";
import NewsList from "./NewsList.vue";
import VisionStatementSlider from "./VisionStatementSlider.vue";
import TimeAllocationWidget from "../agenda/widget/TimeAllocationWidget.vue";
import Widget from "../widget/Widget.vue";
import MessageSheet from "/src/components/MessageSheet.vue";
import { createUUID } from "/src/utils/util";
import Loader from "../Loader.vue";
import WidgetConfiguration from "/src/components/dashboard/WidgetConfiguration.vue";
import ConfirmDialog from "../ConfirmDialog.vue";
import PreventNavigation from "@/components/PreventNavigation.vue";
import SignalRMixin from "../../mixin/SignalRMixin";
import MatrixView from "./MatrixView.vue";
import AMenu from "../../wrapper-component/AMenu.vue";
import PowerBIWidget from "../agenda/widget/PowerBIWidget.vue";

import {
  skillsList,
  personalityTypesList,
  companyNewsIds,
} from "../../utils/constant";

export default {
  name: "DashboardWidget",
  mixins: [SignalRMixin],
  props: [],
  components: {
    MessageSheet,
    Loader,
    WidgetConfiguration,
    ConfirmDialog,
    PreventNavigation,
    AMenu,
  },

  data() {
    return {
      showWidgetDialog: false,
      percentage: 0,
      settingMenu: false,
      editable: false,
      zoom_type: 10,
      spacing: [2, 2],
      aspectRatio: 7,
      Loaderloading: true,
      mediaQuery: "max-width: 767px",
      displayMessage: false,
      messageType: "",
      message: "",
      panelConfig: [],
      allowResizing: false,
      allowDragging: false,
      containerSize: {},
      isDashboardPanelmodified: false,
      UpcomingMeetingList: function () {
        return { template: UpcomingMeetingList };
      },
      UpcomingSurveyList: function () {
        return { template: UpcomingSurveyList };
      },
      NewsList(props) {
        return () => {
          return {
            template: {
              extends: NewsList,
              propsData: { companyId: props },
            },
          };
        };
      },
      VisionStatementSlider: function () {
        return { template: VisionStatementSlider };
      },
      TimeAllocationWidget: function () {
        return { template: TimeAllocationWidget };
      },
      MatrixViewWidget(props) {
        return () => {
          return {
            template: {
              extends: MatrixView,
              propsData: { widgetData: props },
            },
          };
        };
      },
      DynamicWidget(props) {
        return () => {
          return {
            template: {
              extends: Widget,
              propsData: { widgetData: props },
            },
          };
        };
      },
      PowerBIWidget: function () {
        return { template: PowerBIWidget };
      },
    };
  },
  async mounted() {
    this.setZoom(this.zoom_type);
    this.removeHoldWidgetList();
    await this.getPanelWidgetApi();
    await this.setUpTenantConfigList();
    this.disableOnloadApi();
    this.setDefaultSettings();
    this.initializeTemplateDynamic();
    this.setContainerSize();
    await this.signalRInit(`widgets_${this.selectedTenant}`);
    this.$eventHub.$on("onCreateWidget", this.onAddWidget);
    this.$eventHub.$on("onUpdateWidget", this.onUpdateWidget);
    this.$eventHub.$on("onDeleteWidget", this.onDeleteWidget);
    this.$eventHub.$on("onDisableWidget", this.onDisableWidget);
  },
  beforeDestroy() {
    this.$eventHub.$off("onCreateWidget");
    this.$eventHub.$off("onUpdateWidget");
    this.$eventHub.$off("onDeleteWidget");
    this.$eventHub.$off("onDisableWidget");
  },
  computed: {
    LoaderText() {
      return this.$t("LoaderText");
    },
    dashboardInstance() {
      if (
        this.$refs.DashbordInstance &&
        this.$refs.DashbordInstance.$el &&
        this.$refs.DashbordInstance.$el.ej2_instances.length > 0
      ) {
        return this.$refs.DashbordInstance.$el.ej2_instances[0];
      } else {
        return null;
      }
    },
    cellAspectRatio() {
      return this.aspectRatio;
    },
    ...mapState({
      getDashboardWidgets: (state) => state.widget.panelWidgets,
      disableWidgetList: (state) => state.widget.disableWidgets,
    }),
    ...mapGetters({
      tenantSettingTypes: "tenant/tenantSettingTypes",
      getWidgets: "widget/dashboardWidgets",
      defaultWidgets: "widget/defaultWidget",
      diableCount: "widget/diableCount",
      tenantSettingConfig: "tenant/tenantSettingConfig",
      tenantSettingTypes: "tenant/tenantSettingTypes",
      getLastRow: "widget/getLastRow",
    }),
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    panelConfigKey() {
      return "panelConfig#" + this.selectedTenant;
    },
    localPanelConfigKey() {
      return "localPanelConfig#" + this.selectedTenant;
    },
    disableWidgetKey() {
      return "disableWidgets#" + this.selectedTenant;
    },
    ...mapGetters({
      tenantSettingTypes: "tenant/tenantSettingTypes",
    }),

    peoplePersonalityTypes() {
      return this.tenantSettingTypes("personalityTypes");
    },
    isCustomDashboard() {
      const panelObj = this.panelConfig.filter(
        (item) => item.isDefault !== true
      );
      return panelObj.length;
    },
    companyNewsId() {
      const newsId = this.tenantSettingTypes("companyNews");
      return newsId ? newsId[0] : null;
    },

    personalityTypesHeaders() {
      let list = this.peoplePersonalityTypes.map((pt) => {
        return {
          id: createUUID(),
          name: pt.name,
          value: pt.value,
        };
      });

      list.unshift({
        id: createUUID(),
        name: "People",
        value: "people",
      });
      return list;
    },
  },
  watch: {
    editable(value) {
      this.widgetHandler();
    },
    isDashboardPanelmodified(value) {
      this.$emit("leave", !value);
    },
  },

  methods: {
    onResize() {
      this.aspectRatio = window.innerWidth / 190;
    },
    ...mapActions({
      getPanelWidgetApi: "widget/getPanelWidgets",
      disableOnloadApi: "widget/disableOnload",
      getAgendaListApi: "agenda/getAgendaList",
      setLastRowIndexAction: "widget/setLastRowIndex",
      updateTenantConfig: "tenant/updateTenantConfig",
      createTenantConfig: "tenant/createTenantConfig",
      widgetEnableApi: "widget/widgetEnable",
      removeHoldWidgetList: "widget/removeHoldWidgetList",
    }),
    async signalRInit(target) {
      await this.signalConnection.on(target, async (message) => {
        const result = JSON.parse(message);
        if (result) {
          await this.getPanelWidgetApi();
          const proxy = this;
          setTimeout(function () {
            proxy.initializeTemplateDynamic();
          }, 500);
        }
      });
      if (
        this.signalConnection.connectionState.toLowerCase() === "disconnected"
      ) {
        this.signalConnection.start().catch();
      }
    },
    refreshWidgetPanel(panel) {
      this.initializeTemplateDynamic();
    },
    openWidgetDialog() {
      this.showWidgetDialog = true;
    },
    widgetHandler() {
      this.dashboardWidgetEditable(this.editable);
    },
    refresh() {
      if (this.dashboardInstance !== null) {
        this.dashboardInstance.refresh();
      }
    },
    saveDashboardChanges() {
      try {
        this.Loaderloading = true;
        this.onPanelAdjust();
        this.displayMessage = true;
        this.messageType = "success";
        this.message = this.$t("dashboard.msgDashboardLayoutPositionSave");
        this.Loaderloading = false;
        this.isDashboardPanelmodified = false;
      } catch (error) {
        this.Loaderloading = false;
      }
    },
    async resetDefaultDashboard() {
      if (
        await this.$refs.confirm.open(
          this.$t("dashboard.lblConfirmReset"),
          this.$t("dashboard.msgConfirmReset"),
          { yesNoButtons: true }
        )
      ) {
        this.panelConfig = localStorage.getItem(this.panelConfigKey)
          ? JSON.parse(localStorage.getItem(this.panelConfigKey))
          : [];
        if (this.panelConfig.length > 0) {
          localStorage.removeItem(this.panelConfigKey);
          this.panelConfig = [];
        }

        if (localStorage.getItem(this.localPanelConfigKey)) {
          localStorage.removeItem(this.localPanelConfigKey);
        }

        if (localStorage.getItem(this.disableWidgetKey)) {
          localStorage.removeItem(this.disableWidgetKey);
        }
        this.removeHoldWidgetList();
        this.resetDashboard();
        this.isDashboardPanelmodified = false;
      }
    },
    setZoom(zoom) {
      if (zoom == "in") {
        this.zoom_type > 1 ? this.zoom_type-- : 0;
        this.percentage = this.zoom_type * 10;
      } else {
        this.zoom_type < 10 ? this.zoom_type++ : 10;
        this.percentage = this.zoom_type * 10;
      }

      this.containerZoomInOut(this.zoom_type);
    },
    async saveDefaultWidgetSettings() {
      try {
        this.Loaderloading = true;
        const ws = this.tenantSettingConfig("dashboardlayout");
        if (this.dashboardInstance === null) {
          this.Loaderloading = false;
          return false;
        }
        const panelList = this.dashboardInstance.panels;
        const panelConfig = [];
        if (panelList.length > 0) {
          for (let i = 0; i < panelList.length; i++) {
            const panel = panelList[i].properties;
            const dataArgs = {
              id: panel.id,
              row: panel.row,
              col: panel.col,
              sizeX: panel.sizeX,
              sizeY: panel.sizeY,
              minSizeX: panel.minSizeX,
              minSizeY: panel.minSizeY,
            };
            panelConfig.push(dataArgs);
          }

          let widgetEnableList = [];

          if (this.disableWidgetList) {
            localStorage.setItem(
              this.disableWidgetKey,
              JSON.stringify(this.disableWidgetList)
            );
            widgetEnableList = this.disableWidgetList;
          } else if (localStorage.getItem(this.disableWidgetKey)) {
            widgetEnableList = JSON.parse(
              localStorage.getItem(this.disableWidgetKey)
            );
          }

          localStorage.setItem(
            this.panelConfigKey,
            JSON.stringify(this.panelConfig)
          );
          if (localStorage.getItem(this.localPanelConfigKey)) {
            localStorage.removeItem(this.localPanelConfigKey);
          }

          if (ws && ws.id) {
            const widgetsetting = {
              id: ws.id,
              tenantid: ws.tenantid,
              configname: ws.configname,
              dashboardlayout: {
                panelConfig: panelConfig,
                widgetEnable: widgetEnableList,
              },
            };
            await this.updateTenantConfig(widgetsetting);
            this.displayMessage = true;
            this.messageType = "success";
            this.message = this.$t("dashboard.msgDashboardLayoutUpdate");
          } else {
            const widgetSetting = {
              id: createUUID(),
              tenantid: sessionStorage.getItem("tenantId"),
              configname: "dashboardlayout",
              dashboardlayout: {
                panelConfig: panelConfig,
                widgetEnable: widgetEnableList,
              },
            };
            this.createTenantConfig(widgetSetting);
            this.displayMessage = true;
            this.messageType = "success";
            this.message = this.$t("dashboard.msgDashboardLayoutSave");
          }
          this.Loaderloading = false;
          this.isDashboardPanelmodified = false;
        }
        this.Loaderloading = false;
      } catch (error) {
        this.Loaderloading = false;
      }
    },
    setUpTenantConfigList,
    saveOnLeave,
    dashboardWidgetEditable(edit) {
      this.allowResizing = edit;
      this.allowDragging = edit;
    },
    resetDashboard() {
      localStorage.removeItem(this.panelConfigKey);
      this.setDefaultSettings();
      this.widgetEnableApi();
      const proxy = this;
      setTimeout(function () {
        proxy.initializeTemplateDynamic();
      }, 500);
    },
    onDisableWidget(data) {
      const proxy = this;
      proxy.lastRowIndex();
      if (!proxy.dashboardInstance) {
        return false;
      }
      const DashbordInstance = proxy.dashboardInstance;
      const foundIndex = DashbordInstance.panels.findIndex(
        (d) => d.id == data.id
      );
      if (foundIndex !== -1 && data.isShow == false) {
        DashbordInstance.removePanel(DashbordInstance.panels[foundIndex].id);
      } else if (data.isShow == true) {
        var panelIndex = this.getWidgets.findIndex((d) => d.id == data.id);
        const widget = this.getWidgets[panelIndex];
        widget.row = this.getLastRow;
        this.addNewPanel(widget);
      }
      DashbordInstance.refresh();
    },
    onUpdateWidget(panel) {
      const proxy = this;
      if (!proxy.dashboardInstance) {
        return false;
      }
      const DashbordInstance = proxy.dashboardInstance;
      const foundIndex = DashbordInstance.panels.findIndex(
        (d) => d.id == panel.id
      );
      if (foundIndex !== -1) {
        DashbordInstance.panels[foundIndex].content =
          panel.widgetType == "upcomingmeetinglist"
            ? this.UpcomingMeetingList
            : panel.widgetType == "upcomingsurveys"
            ? this.UpcomingSurveyList
            : panel.widgetType == "news"
            ? this.NewsList(this.companyNewsId)
            : panel.widgetType == "time"
            ? this.TimeAllocationWidget
            : panel.widgetType == "skillmatrix"
            ? this.MatrixViewWidget(panel)
            : panel.widgetType == "PowerBIIntegration"
            ? this.PowerBIWidget
            : this.DynamicWidget(panel);
      }
      DashbordInstance.refresh();
      this.lastRowIndex();
    },
    onAddWidget(panel) {
      this.addNewPanel(panel);
      this.onPanelAdjust();
    },
    onDeleteWidget(id) {
      const proxy = this;
      if (!proxy.dashboardInstance) {
        return false;
      }
      const DashbordInstance = proxy.dashboardInstance;
      const foundIndex = DashbordInstance.panels.findIndex((d) => d.id == id);
      if (foundIndex !== -1) {
        DashbordInstance.removePanel(DashbordInstance.panels[foundIndex].id);
        DashbordInstance.refresh();
        this.onPanelAdjust();
        this.lastRowIndex();
      }
    },
    initializeTemplateDynamic: function () {
      const proxy = this;
      if (!proxy.dashboardInstance) {
        return false;
      }
      proxy.dashboardInstance.removeAll();
      var panel = this.getWidgets;
      var updatedPanels = [];
      for (let i = 0; i < panel.length; i++) {
        if (panel[i].isShow === false) {
          continue;
        }
        //Skip dublicate pre-configured widgettypes.         
       const panelIndex = updatedPanels.filter((d) => (d.widgetType === panel[i].widgetType && panel[i].isDynamicContent==1));            
        if (panelIndex.length > 0) 
        {      
          continue;
        }   
        const widgetSetting = this.getWidgetSetting(panel[i].id);

        let panelData = panel[i];
        if (widgetSetting) {
          panelData = widgetSetting;
        }      

        var panelModelValue = {
          id: panel[i].id,
          row: Number(panelData.row),
          col: Number(panelData.col),
          sizeX: Number(panelData.sizeX),
          sizeY: Number(panelData.sizeY),
          title: panel[i].title,
          widgetType: panel[i].widgetType,
          content:
            panel[i].widgetType == "upcomingmeetinglist"
              ? this.UpcomingMeetingList
              : panel[i].widgetType == "upcomingsurveys"
              ? this.UpcomingSurveyList
              : panel[i].widgetType == "news"
              ? this.NewsList(this.companyNewsId)
              : panel[i].widgetType == "time"
              ? this.TimeAllocationWidget
              : panel[i].widgetType == "skillmatrix"
              ? this.MatrixViewWidget(panel[i])
              : panel[i].widgetType == "PowerBIIntegration"
              ? this.PowerBIWidget
              : this.DynamicWidget(panel[i]),
        };
          updatedPanels.push(panelModelValue);       
      }

      setTimeout(function () {
        if (proxy.dashboardInstance) {
          proxy.dashboardInstance.panels = updatedPanels;
        }
        proxy.dashboardInstance.refresh();
        proxy.lastRowIndex();
        proxy.Loaderloading = false;
      }, 500);
    },

    lastRowIndex() {
      const proxy = this;
      if (!proxy.dashboardInstance) {
        return false;
      }
      const DashbordInstance = proxy.dashboardInstance;

      const panelList = DashbordInstance.serialize();
      const sortedList = _.orderBy(panelList, ["row"], ["asc"]);
      const reArrangeRows = [];
      for (let i = 0; i < panelList.length; i++) {
        reArrangeRows.push(Number(panelList[i].row ? panelList[i].row : 0));
      }
      const col = sortedList[panelList.length - 1];
      proxy.setLastRowIndexAction(
        Number(Math.max(...reArrangeRows)) + Number(col ? col.sizeY ?? 0 : 0)
      );
    },
    addNewPanel(panel) {
      const proxy = this;

      var panelModelValue = {
        id: panel.id,
        row: Number(panel.row),
        col: Number(panel.col),
        sizeX: Number(panel.sizeX),
        sizeY: Number(panel.sizeY),
        content:
          panel.widgetType == "upcomingmeetinglist"
            ? this.UpcomingMeetingList
            : panel.widgetType == "upcomingsurveys"
            ? this.UpcomingSurveyList
            : panel.widgetType == "news"
            ? this.NewsList(this.companyNewsId)
            : panel.widgetType == "time"
            ? this.TimeAllocationWidget
            : panel.widgetType == "skillmatrix"
            ? this.MatrixViewWidget(panel)
            : panel.widgetType == "PowerBIIntegration"
            ? this.PowerBIWidget
            : this.DynamicWidget(panel),
      };
      if (proxy.dashboardInstance) {
        proxy.dashboardInstance.addPanel(panelModelValue);
        proxy.dashboardInstance.refresh();
      }
      proxy.lastRowIndex();
    },
    addPanel(panel) {
      const proxy = this;
      const DashbordInstance =
        proxy.$refs.DashbordInstance.$el.ej2_instances[0];
      const widgetSetting = this.getWidgetSetting(panel.id);
      let panelData = panel;
      if (widgetSetting) {
        panelData = widgetSetting;
      }
      var panelModelValue = {
        id: panel.id,
        row: Number(panelData.row),
        col: Number(panelData.col),
        sizeX: Number(panelData.sizeX),
        sizeY: Number(panelData.sizeY),
        content:
          panel.widgetType == "upcomingmeetinglist"
            ? this.UpcomingMeetingList
            : panel.widgetType == "upcomingsurveys"
            ? this.UpcomingSurveyList
            : panel.widgetType == "news"
            ? this.NewsList(this.companyNewsId)
            : panel.widgetType == "time"
            ? this.TimeAllocationWidget
            : panel.widgetType == "skillmatrix"
            ? this.MatrixViewWidget(panel)
            : panel.widgetType == "PowerBIIntegration"
            ? this.PowerBIWidget
            : this.DynamicWidget(panel),
      };
      DashbordInstance.addPanel(panelModelValue);
    },
    setDefaultSettings() {
      this.panelConfig = localStorage.getItem(this.panelConfigKey)
        ? JSON.parse(localStorage.getItem(this.panelConfigKey))
        : [];
      const localSetting = localStorage.getItem(this.localPanelConfigKey)
        ? JSON.parse(localStorage.getItem(this.localPanelConfigKey))
        : [];

      if (this.panelConfig.length == 0 || localSetting.length > 0) {
        const wSetting = this.tenantSettingTypes("dashboardlayout");
        if (wSetting.panelConfig && wSetting.panelConfig.length > 0) {
          this.panelConfig = wSetting.panelConfig.map((v) => ({
            ...v,
            isDefault: true,
          }));
          if (localSetting.length > 0) {
            localStorage.setItem(
              this.panelConfigKey,
              JSON.stringify(localSetting)
            );
          } else {
            localStorage.setItem(
              this.panelConfigKey,
              JSON.stringify(this.panelConfig)
            );
          }
        }
        if (
          !localStorage.getItem(this.disableWidgetKey) &&
          wSetting.widgetEnable &&
          wSetting.widgetEnable.length > 0
        ) {
          localStorage.setItem(
            this.disableWidgetKey,
            JSON.stringify(wSetting.widgetEnable)
          );
        }
      }
    },
    getWidgetSetting: function (id) {
      let panelConfig = localStorage.getItem(this.panelConfigKey)
        ? JSON.parse(localStorage.getItem(this.panelConfigKey))
        : [];
      const localPanelConfig = localStorage.getItem(this.localPanelConfigKey)
        ? JSON.parse(localStorage.getItem(this.localPanelConfigKey))
        : [];
      if (localPanelConfig.length > 0) {
        panelConfig = localPanelConfig;
      }
      const foundIndex = panelConfig.findIndex((panel) => panel.id == id);
      if (foundIndex !== -1) {
        return panelConfig[foundIndex];
      } else {
        return false;
      }
    },
    onPanelAdjust: function () {
      if (this.dashboardInstance === null) {
        return false;
      }
      const panelList = this.dashboardInstance.serialize();
      if (localStorage.getItem(this.panelConfigKey)) {
        localStorage.removeItem(this.panelConfigKey);
      }
      if (panelList.length > 0) {
        //localStorage.setItem("panelConfig", JSON.stringify(panelList));
        localStorage.setItem(
          this.localPanelConfigKey,
          JSON.stringify(panelList)
        );
        if (this.disableWidgetList) {
          localStorage.setItem(
            this.disableWidgetKey,
            JSON.stringify(this.disableWidgetList)
          );
        }
      }
    },
    setContainerSize() {
      const defaultLayout = document.getElementById("defaultLayout");
      if (defaultLayout) {
        this.containerSize = {
          width: defaultLayout.clientWidth,
          height: defaultLayout.clientHeight,
        };
      }
    },
    containerZoomInOutOld(zoom) {
      const defaultLayout = document.getElementById("defaultLayout");
      const scale = zoom / 10;
      if (defaultLayout) {
        defaultLayout.style.transform = `scale(${scale})`;
      }
    },
    containerZoomInOut(zoom) {
      const defaultLayout = document.getElementById("defaultLayout");
      if (defaultLayout) {
        const width = ((zoom * 10) / 100) * this.containerSize.width;
        const height = (this.containerSize.height / (zoom / 10)) * 100;
        defaultLayout.parentElement.style.width = `${width}px`;
        defaultLayout.parentElement.style.margin = "auto";

        if (this.dashboardInstance !== null) {
          this.dashboardInstance.refresh();
        }
      }
    },
    onPanelResize: function (args) {
      if (args.element.children.length) {
        const parent = args.element.children[0];
        if (parent.children.length) {
          const elementId = parent.children[0].id;
          const element = document.getElementById(elementId);
          let panelBodyHeight;

          const mainComponent = parent.children[0].children[0];

          if (element) {
            panelBodyHeight = element.offsetHeight - 48;

            if (
              mainComponent.children[1].className.includes("surveypoll-card")
            ) {
              mainComponent.children[1].style.height = `${panelBodyHeight}px`;
            } else if (
              mainComponent.children[1].className.includes("meeting-card")
            ) {
              mainComponent.children[1].style.height = `${panelBodyHeight}px`;
            } else if (
              mainComponent.children[1].className.includes(
                "time-allocation-card"
              )
            ) {
              mainComponent.children[1].style.height = `${panelBodyHeight}px`;
            } else if (
              mainComponent.children[1].children[0].className.includes(
                "pdf-viewer-card"
              )
            ) {
              if (mainComponent.children[0].childElementCount) {
                const headerHeight = mainComponent.children[0].offsetHeight;
                mainComponent.children[1].children[0].style.height = `${
                  element.offsetHeight - headerHeight
                }px`;
              }
            } else if (
              mainComponent.children[1].className.includes("people-table")
            ) {
              mainComponent.children[1].style.height = `${panelBodyHeight}px`;
            } else if (
              mainComponent.children[1].children[0].className.includes(
                "image-viewer-card"
              )
            ) {
              if (mainComponent.children[0].childElementCount) {
                const headerHeight = mainComponent.children[0].offsetHeight;
                mainComponent.children[1].children[0].style.height = `${
                  element.offsetHeight - headerHeight
                }px`;
              }
            } else if (
              mainComponent.children[1].className.includes("news-list-card")
            ) {
              mainComponent.children[1].style.height = `${panelBodyHeight}px`;
            }
          }
        }
      }
      this.isDashboardPanelmodified = true;
    },
    onDragStop: function (args) {
      this.isDashboardPanelmodified = true;
    },
  },
};

function saveOnLeave({ next }) {
  this.saveDashboardChanges();
  this.displayMessage = true;
  this.messageType = "success";
  this.message = this.$t("dashboard.msgDashboardLayoutPositionSave");
  next();
}

async function setUpTenantConfigList() {
  const tenantSkills = this.tenantSettingConfig("skills");
  if (!tenantSkills) {
    const skillsObj = {
      id: createUUID(),
      tenantid: this.selectedTenant,
      configname: "skills",
      skills: skillsList,
    };
    this.createTenantConfig(skillsObj);
  }
  const personalityTypes = this.tenantSettingConfig("personalityTypes");
  if (!personalityTypes) {
    const personalityTypesObj = {
      id: createUUID(),
      tenantid: this.selectedTenant,
      configname: "personalityTypes",
      personalityTypes: personalityTypesList,
    };
    this.createTenantConfig(personalityTypesObj);
  }

  const companyNews = this.tenantSettingConfig("companyNews");
  if (!companyNews) {
    const companyNewsObj = {
      id: createUUID(),
      tenantid: this.selectedTenant,
      configname: "companyNews",
      companyNews: companyNewsIds,
    };
    this.createTenantConfig(companyNewsObj);
  }
}
</script>

<style>
/* html:has(#defaultLayout){ overflow-y: hidden; } 
.dashboard-container {
  height: calc(100vh - 150px);
  overflow-y: scroll;
  overflow-x:hidden; 
}
*/

.v-application:not(:has(.v-overlay--active)) .v-app-bar.v-app-bar--fixed {
  z-index: 99 !important;
}
.v-application:not(:has(.v-overlay--active)) .v-system-bar.v-system-bar--fixed {
  z-index: 10001 !important;
}
.v-application:not(:has(.v-overlay--active)) .v-navigation-drawer--fixed {
  z-index: 10002 !important;
}
/* .v-overlay{
  z-index: 10001 !important;
}
.v-dialog__content--active{
  z-index: 10002 !important;
} */
.v-toolbar__content {
  position: relative;
}
.editable-mod-text {
  position: absolute;
  left: 45%;
}
.e-panel-content {
  /* overflow: auto; */
}

.header-card {
  position: -webkit-sticky;
  position: sticky;
  top: 0px; /* The height of top nav menu. */
  z-index: 1;
}

.e-panel-content header.pageHeader {
  position: -webkit-sticky;
  position: sticky;
  top: 0px; /* The height of top nav menu. */
  z-index: 1;
}

.e-dashboardlayout.e-control .e-panel {
  background-color: var(--v-neutral-base) !important;
}

.e-dashboardlayout.e-control .e-panel .e-panel-header {
  height: 0px !important;
  padding: 0px !important;
}

#defaultLayout {
  padding: 10px;
  width: 100%;
  min-height: 500px;
}
#defaultLayout .e-panel {
  transition: none !important;
}

.dashboard-default {
  padding: 3px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  /* width: 100%; */
  /* position: relative; */
}

#defaultLayout .panel-content {
  vertical-align: middle;
}

#defaultLayout .e-panel-content {
  /* height: calc(100% - 28px); */
  width: 100%;
  display: block;
}
.dashboard-default {
  padding-bottom: 150px;
}
.dashboard-default .e-template-icon.e-clear-icon {
  display: block;
  z-index: 999;
  color: #fff;
}
.e-dashboardlayout.e-control .e-panel {
  /* z-index: 1 !important; */
  z-index: 1;
}

.dashboard-default #defaultLayout .e-panel .e-panel-container .text-align {
  vertical-align: middle;
  text-align: center;
}

.dashboard-default .e-template-icon {
  padding: 10px;
  float: right;
  display: none;
}

.dashboard-default .e-clear-icon::before {
  content: "\e7a7";
  font-size: 12px;
  font-family: "e-icons";
}
.bootstrap4 .dashboard-default .e-clear-icon::before {
  content: "\e745";
}

.tailwind .dashboard-default .e-clear-icon::before,
.tailwind-dark .dashboard-default .e-clear-icon::before {
  content: "\e771";
  font-size: 16px;
}

.bootstrap5 .dashboard-default .e-clear-icon::before,
.bootstrap5-dark .dashboard-default .e-clear-icon::before {
  content: "\e7e7";
  font-size: 16px;
}

.dashboard-default .e-clear-icon {
  position: absolute;
  right: 0;
  cursor: pointer;
}
/* high contrast style */
body.highcontrast
  .dashboard-default
  #defaultLayout.e-dashboardlayout.e-control
  .e-panel {
  background: #000;
}

body.tailwind-dark .e-dashboardlayout.e-control .e-panel {
  border: 1px solid #d7d7d7;
}
</style>
<style scoped>
::v-deep .v-list-item--dense .v-list-item__icon,
.v-list--dense .v-list-item .v-list-item__icon {
  height: 24px;
  margin-top: 8px;
  margin-bottom: 8px;
  margin-right: 15px;
}
</style>
